






































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { Component, Emit, Prop, Watch } from "vue-property-decorator";
import { required, requiredIf } from "vuelidate/lib/validators";
import Accordion from "../../shared/Accordion.vue";
import {
  CountryDTO,
  SubcountryDTO,
  AddressShipmentDTO,
  ZipRegistryEntryDto,
  AddressLocatorDto
} from "@/model/data.model";
import { ShipmentService } from "@/services/ShipmentService";
import { Pageable, TranslatedCountryDTO } from "@/model/component.model";
import Modal from "../../shared/modal/Modal.vue";
import { emailValidator } from "../../../definitions/email-validator";
import isPhone from "../../../definitions/telephone-validator";
import i18n from "../../../lang/i18n";
import { isFrance } from "@/services/Helpers";
import store from "@/vuex/store";
import addressDisplay from "@/filters/AddressFilter";

@Component({
  components: {
    Accordion: Accordion,
    MbeModal: Modal
  },
  validations(): any {
    const self = this as any;
    return {
      address: {
        address: { required },
        companyName: { required },
        zipCode: {
          required: requiredIf(
            () => this.$props.address.countryName !== "Hong Kong"
          )
        },
        city: { required },
        countryName: { required },
        subcountry: { required },
        email: {
          emailValid: (value: any) => {
            return emailValidator(
              value,
              undefined,
              this.$props.formType == "receiver" && self.isUSTariffShipment
            );
          },
          required: requiredIf(
            () =>
              this.$props.isEmailRequired ||
              (this.$route.query.type === "inbound" &&
                this.$props.isEmailRequiredNew) ||
              (this.$props.isGel && this.$props.formType == "receiver") ||
              (this.$props.formType == "receiver" && self.isUSTariffShipment) ||
              ((this.$props.formType == "receiver" ||
                this.$props.formType == "sender") &&
                self.isWWShip) ||
              (this.$props.isWineShipment && this.$props.formType == "receiver")
          )
        },
        secondEmail: { emailValidator },
        contact: {
          required: requiredIf(
            () =>
              self.$props.isContactRequired ||
              (self.$props.isWineShipment &&
                self.$props.formType == "receiver") ||
              self.$props.pickupRequested
          )
        },
        phone: {
          validatePhone: (value: any) => {
            return isPhone(
              value,
              this.$props.formType == "receiver" && self.isUSTariffShipment
            );
          },
          required: requiredIf(
            () =>
              this.$route.query.type === "inbound" ||
              this.$props.isPhoneRequired ||
              (this.$props.isGel && this.$props.formType == "receiver") ||
              (this.$props.formType == "receiver" && self.isUSTariffShipment) ||
              ((this.$props.formType == "receiver" ||
                this.$props.formType == "sender") &&
                self.isWWShip) ||
              this.$props.pickupRequested ||
              (this.$props.isWineShipment && this.$props.formType == "receiver")
          )
        },
        secondPhone: {
          validatePhone: (value: any) => {
            return isPhone(
              value,
              this.$props.formType == "receiver" && self.isUSTariffShipment
            );
          }
        },
        province: {}
      }
    };
  }
})
export default class Address extends Vue {
  @Prop() label: string;
  @Prop() countries: TranslatedCountryDTO[];
  @Prop() address: AddressShipmentDTO;
  @Prop() addressAccessPoint: AddressLocatorDto;
  @Prop() hasAccessPoint: boolean;
  @Prop() black: boolean;
  @Prop() blue: boolean;
  @Prop() isPhoneRequired: boolean;
  @Prop({ default: false }) isContactRequired: boolean;
  @Prop() isEmailRequired: boolean;
  @Prop() isEmailRequiredNew: boolean;
  @Prop({ default: false }) accordionOpened: boolean;
  changeAccordionState(opened: boolean) {}
  @Prop() isAddressFrom: boolean;
  @Prop({ default: "0" }) isFromShipMng: string;
  @Prop() edition: boolean;
  @Prop() addressOperation: string;
  @Prop() courierName: string;
  @Prop({ default: false }) isUSTariffShipment: boolean;
  @Prop({ default: false }) isWWShip: boolean;
  @Prop() formType: "receiver" | "sender";
  @Prop({ default: true }) showSetAddressAsHome: boolean;
  @Prop({ default: false }) lock: boolean;
  @Prop({ default: false }) isGel: boolean;
  @Prop({ default: false }) isWineShipment: boolean;
  @Prop({ default: "" }) wineProduct: string;
  @Prop({ default: false }) pickupRequested: boolean;
  @Prop({ default: false }) readOnly: boolean;

  subcountries: SubcountryDTO[] = [];
  countryValues: TranslatedCountryDTO[] = [];
  zipRegistryLocations: ZipRegistryEntryDto[] = [];
  showZipRegistryLocationModal = false;
  selectZipRegistry: ZipRegistryEntryDto = {} as ZipRegistryEntryDto;

  get isReceiverAddress() {
    return this.formType === "receiver";
  }

  get isReadOnly() {
    return this.readOnly || this.isFromShipMng == "1";
  }

  get isAccessPointUsed() {
    return this.accesspointId && this.accesspointId.length > 0;
  }

  created() {
    setTimeout(() => {
      if (this.subcountries.length === 0) {
        this.loadSubcountries();
      }
    }, 1000);
  }

  @Watch("address.countryId")
  forceReload() {
    this.$nextTick(() => {
      this.loadSubcountries();
    });
  }

  wineProductChanged() {
    if (
      this.formType === "receiver" &&
      (this.wineProduct === "wine_us" || this.wineProduct === "spirits_us")
    ) {
      if (this.address.countryId !== "US") {
        this.clearFields("receiver");
        console.trace();
        this.$nextTick(() => {
          const countryUS = this.countries.find(
            (item: CountryDTO) => item.id === "US"
          );
          this.countryModified(countryUS);
        });
      }
    }
  }

  @Emit("clearFields")
  clearFields(shipmentType: string) {
    return shipmentType;
  }

  // when loading an address from contacts the operation is set to DONTSAVE as default,
  // if any parameter of address is changed, change the operation to OVERWERITE
  fieldEdited(value: string | number, field: string) {
    const clean = typeof value === "string" ? value.trim() : value;
    if (clean !== this.address[field]) {
      this.address[field] = clean;
      this.$emit("contactInfoChanged");
    }
  }

  get country(): CountryDTO | null {
    const countries = this.countries.filter((item: CountryDTO) => {
      if (item.id.split("_") && item.id.split("_").length > 1) {
        return item.id.split("_")[1] == this.address.countryId;
      } else {
        return item.id == this.address.countryId;
      }
    });

    if (countries.length > 0) {
      this.countryValues = countries;
      return countries[0];
    } else {
      return null;
    }
  }

  set country(item: CountryDTO | null) {
    if (item !== null) {
      this.address.countryId = item.id;
      this.address.countryName = item.name;
      if (this.edition) {
        this.loadSubcountries();
      }
    }
  }

  get accesspointId() {
    if (
      this.addressAccessPoint !== undefined &&
      Object.keys(this.addressAccessPoint).length > 0
    ) {
      return this.addressAccessPoint.upsPublicAccessPointId;
    }
    return "";
  }

  countryModified(item: CountryDTO) {
    if (this.address.countryName !== item.name) {
      this.country = item;
      this.$emit("countryModified");
    }
  }
  cityModified() {
    this.$emit("cityModified");
  }

  get isInboundShipment() {
    return this.$route.query.type === "inbound";
  }

  loadSubcountries(): Promise<any> {
    if (this.address.countryId) {
      const storeZipCode = this.$store.getters["customer/storeAddresses"][0]
        .zipCode;
      const storeIsoCode = this.$store.getters["customer/storeAddresses"][0]
        .countryId;
      return store.cache
        .dispatch(
          "cachemod/getSubcountries",
          {
            countryId: this.address.countryId,
            zipcode: this.address.zipCode,
            storeZipCode: storeZipCode,
            storeIsoCode: storeIsoCode
          },
          { timeout: store.state["cachemod"].timeouts.subCountries }
        )
        .then((res: SubcountryDTO[]) => {
          if (res !== undefined) {
            this.subcountries = res;
            if (this.subcountries.length === 1) {
              this.address.cee = this.subcountries[0].cee;
              this.subcountry = this.subcountries[0];
              this.subcountryModified(this.subcountry);
            }
            if (this.subcountries.length === 0) {
              this.subcountry = null;
            }
          } else {
            if (this.subcountries.length > 0) {
              this.subcountries = [];
            }
          }
        })
        .catch(() =>
          this.$snotify.error(this.$t("error_getting_subcountries").toString())
        );
    } else {
      return Promise.resolve(null);
    }
  }

  get subcountry(): SubcountryDTO | null {
    const filteredSubcountries = this.subcountries.filter(
      (item: SubcountryDTO) => {
        return item.idSubcountry == this.address.subcountryId;
      }
    );

    if (filteredSubcountries.length === 1) {
      return filteredSubcountries[0];
    } else {
      return null;
    }
  }

  set subcountry(item: SubcountryDTO | null) {
    // computing macroarea name in out-bound shipment (not working in the inbound)
    if (item == null) {
      this.address.subcountryId = 0;
      this.address.subcountry = "";
      this.address.macroareaName = "";
    } else {
      this.address.subcountryId = item.idSubcountry;
      this.address.subcountry = item.description;
      this.address.macroareaName =
        item.macroareaName === null ? "" : item.macroareaName;
      this.address.cee = item.cee;
    }
  }

  subcountryModified(item: SubcountryDTO) {
    if (this.address.subcountry !== item.description) {
      this.subcountry = item;
      this.address.cee = item.cee;
      this.$emit("subcountryModified", item);
    }
  }

  res = false;
  gdo = false;
  ltz = false;

  checkboxClicked(selector: string) {
    if (this.edition) {
      switch (selector) {
        case "res":
          this.checkboxResidential = !this.checkboxResidential;
          break;
        case "gdo":
          this.checkboxGDO = !this.checkboxGDO;
          break;
        case "ltz":
          this.checkboxLTZ = !this.checkboxLTZ;
          break;
      }
    }
  }

  setAddressAsHome() {
    this.$emit("setAddressAsHome");
    this.$nextTick(() => {
      this.loadSubcountries();
    });
  }

  searchZipRegistryLocation() {
    this.selectZipRegistry = {} as ZipRegistryEntryDto;
    if (
      this.address &&
      (!this.address.countryId || this.address.countryId === "")
    ) {
      return;
    }

    ShipmentService.prototype
      .getZipRegistry(
        this.address.countryId,
        this.address.zipCode,
        this.address.province,
        this.address.city
      )
      .then((res: any) => {
        const data = res.data as Pageable<ZipRegistryEntryDto>;
        if (data) {
          if (data.content.length === 1) {
            this.selectLocation(data.content[0], true);
          } else {
            if (data.content.length > 0) {
              this.zipRegistryLocations = data.content;
              this.showZipRegistryLocationModal = true;
            } else {
              if (this.address.province || this.address.city) {
                this.address.province = "";
                this.address.city = "";
                this.searchZipRegistryLocation();
              } else {
                this.$snotify.error(String(i18n.t("no_location_found")));
              }
            }
          }
        }
      })
      .catch((err: any) => {
        this.$snotify.error(err.message);
      });
  }

  selectLocation(location: ZipRegistryEntryDto, fromWorldIcon?: boolean) {
    this.address.countryId = location.id.country;
    this.address.province =
      location.id && location.id.province ? location.id.province.trim() : "";
    this.address.city = location.id.townName;
    this.address.zipCode = this.resolveZipCode(location);
    this.selectZipRegistry = location;

    if (fromWorldIcon) {
      this.loadSubcountries();
    }
  }

  resolveZipCode(location: ZipRegistryEntryDto): string {
    const currentZipCode = this.address.zipCode;
    if (currentZipCode === "") {
      return location.id.postcodeFrom;
    }

    const currentZipCodeUpperCase = currentZipCode.toUpperCase();
    if (
      currentZipCodeUpperCase >= location.id.postcodeFrom &&
      currentZipCodeUpperCase <= location.id.postcodeUntil
    ) {
      return currentZipCodeUpperCase;
    }
    if (
      currentZipCode >= location.id.postcodeFrom &&
      currentZipCode <= location.id.postcodeUntil
    ) {
      return currentZipCode;
    }
    if (location.id.postcodeFrom == location.id.postcodeUntil) {
      return location.id.postcodeFrom;
    }
    return currentZipCode;
  }

  toggleShowZipRegistryLocationModal() {
    this.showZipRegistryLocationModal = !this.showZipRegistryLocationModal;
  }

  set checkboxResidential(value: boolean) {
    this.address.residential = true;
    this.address.supermarket = false;
    //this.address.ltz = false
    if (value) {
      this.address.flavour = "RESIDENTIAL";
    } else {
      this.address.flavour = "NONE";
    }
    this.res = value;
    this.gdo = false;
    //this.ltz = false
  }

  get checkboxResidential(): boolean {
    return this.res;
  }

  set checkboxGDO(value: boolean) {
    this.address.residential = false;
    this.address.supermarket = true;
    this.address.ltz = false;
    if (value) {
      this.address.flavour = "MMR";
    } else {
      this.address.flavour = "NONE";
    }
    this.gdo = value;
    this.res = false;
    //this.ltz = false
  }

  get checkboxGDO(): boolean {
    return this.gdo;
  }

  set checkboxLTZ(value: boolean) {
    //this.address.residential = false
    //this.address.supermarket = false
    this.address.ltz = true;
    //this.address.flavour = "NONE"
    this.ltz = value;
    //this.res = false
    //this.gdo = false
  }

  get checkboxLTZ(): boolean {
    return this.ltz;
  }

  get addressTitleBold() {
    if (this.accesspointId && this.accesspointId.length > 0) {
      return `${this.label} (${this.$t("access_point")}: ${
        this.accesspointId
      })`;
    }
    return this.label;
  }

  senderAsString(): string {
    if (!this.accordionOpened && this.subcountries.length === 0) {
      this.loadSubcountries();
    }

    let s = this.address.companyName;
    const addrText = addressDisplay(this.address);
    if (addrText) {
      s += " - " + addrText;
    }
    return s;
  }

  get isFrance() {
    return isFrance;
  }

  get isItaly() {
    return this.address.countryName === "Italy";
  }

  set provinceInput(value) {
    const province = typeof value === "string" ? value.trim() : value;
    this.address.province = this.isItaly ? province.toUpperCase() : province;
  }

  get provinceInput() {
    return this.address.province;
  }

  get locationSelected() {
    if (this.selectZipRegistry.id === undefined) {
      return false;
    }
    return (
      this.selectZipRegistry.id.townName === this.address.city &&
      this.selectZipRegistry.id.province === this.address.province &&
      this.address.zipCode >= this.selectZipRegistry.id.postcodeFrom &&
      this.address.zipCode <= this.selectZipRegistry.id.postcodeUntil
    );
  }
  get isEmpty() {
    if (
      this.$t("phone_warning") === "phone_warning" ||
      this.$t("phone_warning") === ""
    ) {
      return true;
    }
    return false;
  }
  get isUSTariffShipmentCheck() {
    return this.$props.formType == "receiver" && this.isUSTariffShipment;
  }
  resetCountriesFiltered() {
    setTimeout(() => {
      this.countryValues = this.countries;
    }, 100);
  }

  get isSaveAsPickupEnabled() {
    return this.$store.getters["customer/config"].pickupEnabled;
  }
}
